/*
 * Copyright (c) 2022. Shivangi Gami
 * All Rights Reserved
 */

export const FETCH_TERMS_AND_CONDITION_LIST_REQUEST = 'FETCH_TERMS_AND_CONDITION_LIST_REQUEST';
export const FETCH_TERMS_AND_CONDITION_LIST_REQUEST_SUCCESS =
  'FETCH_TERMS_AND_CONDITION_LIST_REQUEST_SUCCESS';
export const FETCH_TERMS_AND_CONDITION_LIST_REQUEST_FAILURE =
  'FETCH_TERMS_AND_CONDITION_LIST_REQUEST_FAILURE';

export const LEGAL_DOCUMENT_UPSERT_REQUEST = 'LEGAL_DOCUMENT_UPSERT_REQUEST';
export const LEGAL_DOCUMENT_UPSERT_REQUEST_SUCCESS = 'LEGAL_DOCUMENT_UPSERT_REQUEST_SUCCESS';
export const LEGAL_DOCUMENT_UPSERT_REQUEST_FAILURE = 'LEGAL_DOCUMENT_UPSERT_REQUEST_FAILURE';

export const SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST = 'SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST';
export const SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST_SUCCESS =
  'SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST_SUCCESS';
export const SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST_FAILURE =
  'SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST_FAILURE';

export const LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST = 'LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST';
export const LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST_SUCCESS =
  'LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST_SUCCESS';
export const LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST_FAILURE =
  'LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST_FAILURE';

export const CLEAN_ERRORS = 'CLEAN_ERRORS';

export const FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST =
  'FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST';
export const FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST_SUCCESS =
  'FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST_SUCCESS';
export const FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST_FAILURE =
  'FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST_FAILURE';

export const FETCH_AGREEMENTS_TEMPLATE = 'FETCH_AGREEMENTS_TEMPLATE';
export const FETCH_AGREEMENTS_TEMPLATE_SUCCESS = 'FETCH_AGREEMENTS_TEMPLATE_SUCCESS';
export const FETCH_AGREEMENTS_TEMPLATE_FAILURE = 'FETCH_AGREEMENTS_TEMPLATE_FAILURE';
